<div>
  <!-- <div class="heading__wrapper"
  [class.heading__wrapper--border-only]="!description">
  <h2
    class="font-weight-extrabold heading--highlighted"
    [class]="['heading--'+ color]"
    [class.heading--border]="highlightText"
    >
    <span *ngIf="highlightText" class="heading__highlight-text">
      {{ highlightText | translate }}
    </span>
    {{ title | translate }}
  </h2>
  <p class="tw-mb-0">{{ description | translate }}</p>
</div> -->

  <app-campaign-list
    [campaigns]="campaigns"
    [params]="params"
    [total]="total"
    [isLoading]="isLoading"
    [displayPagination]="false"
    (getCampaignList)="getList($event)"
  ></app-campaign-list>

  @if (redirect && total > take) {
    <div class="tw-mt-8 tw-text-center">
      <a
        class="btn btn-primary-border view-btn tw-w-full"
        [routerLink]="[redirect]"
        [queryParams]="redirectParams"
      >
        {{ 'common.viewAll' | translate }}
      </a>
    </div>
  }
</div>
